import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function ConfirmEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!token) { setState("error"); return; }
    apiClient.post("/auth/confirm-email", { token })
      .then(({ data }) => { setEmail(data.email); setState("ok"); })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0A0F0D] text-white flex flex-col items-center justify-center px-5 text-center">
      <Logo size="lg" />
      <div className="mt-10 max-w-sm">
        {state === "loading" && (
          <div data-testid="confirm-loading" className="flex flex-col items-center gap-3 text-white/60">
            <Loader2 className="h-7 w-7 animate-spin text-lime-400" /> Validation en cours…
          </div>
        )}
        {state === "ok" && (
          <div data-testid="confirm-success" className="flex flex-col items-center gap-3">
            <CheckCircle2 className="h-12 w-12 text-lime-400" />
            <h1 className="font-display text-2xl font-black">Adresse confirmée</h1>
            <p className="text-sm text-white/60">Ton adresse email est maintenant <span className="text-lime-300">{email}</span>. Reconnecte-toi si nécessaire.</p>
            <button data-testid="confirm-goto-login" onClick={() => navigate("/login")}
              className="mt-2 bg-lime-400 text-black font-extrabold px-6 py-3 rounded-xl">Se connecter</button>
          </div>
        )}
        {state === "error" && (
          <div data-testid="confirm-error" className="flex flex-col items-center gap-3">
            <XCircle className="h-12 w-12 text-red-400" />
            <h1 className="font-display text-2xl font-black">Lien invalide ou expiré</h1>
            <p className="text-sm text-white/60">Le lien de confirmation n'est plus valide. Relance la demande depuis ton profil.</p>
            <button onClick={() => navigate("/profil")} className="mt-2 bg-lime-400 text-black font-extrabold px-6 py-3 rounded-xl">Mon profil</button>
          </div>
        )}
      </div>
    </div>
  );
}
